export default __webpack_public_path__ + "static/media/telecom.001addb1.png";